// Global utils
import AuthUtils from 'utils/auth';

// Redux
import {store} from 'store';

// Request utils
import request, {REQUEST_ENV} from 'request';
import {withRayquazaFlag} from 'request';

export const getMenuAvailabilityRequest = async (payload, setState) => {
	const locationId = store.getState().reducerUser?.selectedLocation?.id;
	// payload: {locationId, isChildMenu, searchString, brandLabel, isActive, sortBy, sortOrder, limit, offset}
	if (payload?.brandLabel && payload?.brandLabel?.length) {
		payload.brandLabel = payload.brandLabel.join(', ');
	}
	return request({
		method: 'get',
		url: `${REQUEST_ENV.ORDERHUB_API_HOST}/menu-availability/list`,
		headers: {
	    Authorization: `Bearer ${AuthUtils.sessionToken}`,
	  },
		params: {
			locationId,
			offset: 0,
			limit: 15,
			sortBy: 'menuLabel',
			sortOrder: 'asc',
			...withRayquazaFlag(payload),
		},
	}, setState);
};

export const getLinkedMenuRequest = async (payload, setState) => {
	// payload: {queries: [{locationId, menuAvailabilityId} or {locationId, menuId, brandId}, ...]}
	return request({
		method: 'get',
		url: `${REQUEST_ENV.ORDERHUB_API_HOST}/menu-availability/menu/linked`,
		headers: {
	    Authorization: `Bearer ${AuthUtils.sessionToken}`,
	  },
		params: withRayquazaFlag(payload),
		timeout: 60000,
	}, setState);
};

export const updateMenuAvailabilityRequestJob = async (payload, setState) => {
	// payload: {notes, materialId, requestType, updateTo, menuAvailabilities: [{menuAvailabilityId}]}
	const locationId = store.getState().reducerUser?.selectedLocation?.id;
	return request({
		method: 'post',
		url: `${REQUEST_ENV.ORDERHUB_API_HOST}/menu-availability/request/job/create`,
		headers: {
			Authorization: `Bearer ${AuthUtils.sessionToken}`,
	  },
		data: {
			locationId,
			...withRayquazaFlag(payload),
		},
	}, setState);
};

export const updateMaterialAvailabilityRequestJob = async (payload, setState) => {
	// payload: {notes, materialId, updateTo}
	const locationId = store.getState().reducerUser?.selectedLocation?.id;
	return request({
		method: 'post',
		url: `${REQUEST_ENV.ORDERHUB_API_HOST}/menu-availability/materials/menus`,
		headers: {
			Authorization: `Bearer ${AuthUtils.sessionToken}`,
	  },
		data: {
			locationId,
			...withRayquazaFlag(payload),
		},
	}, setState);
};

export const updateMenuAvailabilityValidity = async details => {
	// payload: {locationId, details: [{menuAvailabilityId, isActive, notes}]}
	const locationId = store.getState().reducerUser?.selectedLocation?.id;
	return request({
		method: 'post',
		url: `${REQUEST_ENV.ORDERHUB_API_HOST}/menu-availability/request/check-menus`,
		headers: {
			Authorization: `Bearer ${AuthUtils.sessionToken}`,
	  },
		data: {
			locationId,
			details,
		},
	});
};

export const getRequestStatusRequest = async (payload, setState) => {
	// payload: {locationId, isChildMenu, brandLabel: [], platformLabel: [], status: [], updateTo: [], limit, offset}
	const locationId = store.getState().reducerUser?.selectedLocation?.id;
	if (payload?.status?.length) {
		payload.status = payload.status.join(',');
	}
	return request({
		method: 'get',
		url: `${REQUEST_ENV.ORDERHUB_API_HOST}/menu-availability/request/jobs`,
		headers: {
			Authorization: `Bearer ${AuthUtils.sessionToken}`,
		},
		params: {
			locationId,
			offset: 0,
			limit: 15,
			...withRayquazaFlag(payload),
		},
	}, setState);
};

export const getRequestStatusRequestDetail = async (payload, setState) => {
	// payload: {jobId}
	const locationId = store.getState().reducerUser?.selectedLocation?.id;
	return request({
		method: 'get',
		url: `${REQUEST_ENV.ORDERHUB_API_HOST}/menu-availability/request/job/details`,
		headers: {
			Authorization: `Bearer ${AuthUtils.sessionToken}`,
		},
		params: {
			locationId,
			...withRayquazaFlag(payload),
		},
	}, setState);
};

export const reprocessFailedJobRequest = async ({jobIds}, setState) => {
	// payload: {jobIds}
	const locationId = store.getState().reducerUser?.selectedLocation?.id;
	return request({
		method: 'post',
		url: `${REQUEST_ENV.ORDERHUB_API_HOST}/menu-availability/request/job/reprocess`,
		headers: {
			Authorization: `Bearer ${AuthUtils.sessionToken}`,
		},
		data: {
			locationId,
			...withRayquazaFlag({jobIds}),
		},
	}, setState);
};

export const reprocessAllFailedJobRequest = async (_, setState) => {
	const locationId = store.getState().reducerUser?.selectedLocation?.id;
	return request({
		method: 'post',
		url: `${REQUEST_ENV.ORDERHUB_API_HOST}/menu-availability/request/job/reprocess/all`,
		headers: {
			Authorization: `Bearer ${AuthUtils.sessionToken}`,
		},
		data: {
			locationId,
		},
	}, setState);
};

export const getMenuAvailabilityRows = async (payload, setState) => {
	const locationId = store.getState().reducerUser?.selectedLocation?.id;
	// payload: {locationId, isChildMenu, searchString, brandLabel, isActive, sortBy, sortOrder, limit, offset}
	if (payload?.brandLabel && payload?.brandLabel?.length) {
		payload.brandLabel = payload.brandLabel.join(', ');
	}
	return request({
		method: 'get',
		url: `${REQUEST_ENV.ORDERHUB_API_HOST}/menu-availability/list-rows`,
		headers: {
	    Authorization: `Bearer ${AuthUtils.sessionToken}`,
	  },
		params: {
			locationId,
			offset: 0,
			limit: 15,
			sortBy: 'menuLabel',
			sortOrder: 'asc',
			...payload,
		},
	}, setState);
};

export const getMenuAvailabilityAllRows = async (payload, setState) => {
	const locationId = store.getState().reducerUser?.selectedLocation?.id;
	// payload: {locationId, isChildMenu, searchString, brandLabel, isActive, sortBy, sortOrder}
	if (payload?.brandLabel && payload?.brandLabel?.length) {
		payload.brandLabel = payload.brandLabel.join(', ');
	}
	return request({
		method: 'get',
		url: `${REQUEST_ENV.ORDERHUB_API_HOST}/menu-availability/list-all`,
		headers: {
	    Authorization: `Bearer ${AuthUtils.sessionToken}`,
	  },
		params: {
			locationId,
			...payload,
		},
	}, setState);
};

export const getAllMaterialList = async (payload, setState) => {
	const locationId = store.getState().reducerUser?.selectedLocation?.id;
	// payload: {materialLabel}
	const response = await request({
		method: 'get',
		url: `${REQUEST_ENV.ORDERHUB_API_HOST}/menu-availability/materials`,
		headers: {
	    Authorization: `Bearer ${AuthUtils.sessionToken}`,
	  },
		params: {
			locationId,
			...withRayquazaFlag(payload),
		},
	}, setState);

	if (response?.success) {
		return {
			...response,
			data: response?.data?.materials,
		};
	}

	return response;
};

export const getMenuListFromMaterial = async (payload, setState) => {
	const locationId = store.getState().reducerUser?.selectedLocation?.id;
	// payload: {materialId}
	return request({
		method: 'get',
		url: `${REQUEST_ENV.ORDERHUB_API_HOST}/menu-availability/materials/menus`,
		headers: {
	    Authorization: `Bearer ${AuthUtils.sessionToken}`,
	  },
		params: {
			locationId,
			...withRayquazaFlag(payload),
		},
	}, setState);
};
